import React from "react";

/**
 * ReportSkeleton
 *
 * Used while reports data is loading.
 * Mimics:
 * - Overview cards
 * - Summary cards
 * - Phase breakdown table
 */
export default function ReportSkeleton() {
  return (
    <div className="space-y-6 animate-pulse">
      {/* Top row – Project overview + actions */}
      <div className="flex items-start justify-between gap-6">
        <div className="flex-1 space-y-3">
          <div className="h-6 w-64 rounded bg-gray-200" />
          <div className="h-4 w-96 rounded bg-gray-100" />
        </div>

        <div className="flex gap-3">
          <div className="h-9 w-24 rounded bg-gray-200" />
          <div className="h-9 w-28 rounded bg-gray-200" />
        </div>
      </div>

      {/* Summary cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {Array.from({ length: 3 }).map((_, i) => (
          <div
            key={i}
            className="rounded-xl border bg-white p-5 space-y-4"
          >
            <div className="h-4 w-32 bg-gray-200 rounded" />
            <div className="h-8 w-20 bg-gray-300 rounded" />
            <div className="h-3 w-full bg-gray-100 rounded" />
          </div>
        ))}
      </div>

      {/* Phase breakdown table skeleton */}
      <div className="rounded-xl border bg-white overflow-hidden">
        <div className="px-6 py-4 border-b">
          <div className="h-4 w-40 bg-gray-200 rounded" />
          <div className="h-3 w-64 bg-gray-100 rounded mt-2" />
        </div>

        <div className="p-6 space-y-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="flex items-center gap-4">
              <div className="h-4 w-40 bg-gray-200 rounded" />
              <div className="h-4 w-16 bg-gray-100 rounded" />
              <div className="h-4 w-16 bg-gray-100 rounded" />
              <div className="h-4 w-16 bg-gray-100 rounded" />
              <div className="h-4 w-16 bg-gray-100 rounded" />
            </div>
          ))}
        </div>
      </div>

      {/* Latest milestones */}
      <div className="rounded-xl border bg-white p-6 space-y-4">
        <div className="h-4 w-40 bg-gray-200 rounded" />
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="h-4 w-full bg-gray-100 rounded" />
        ))}
      </div>
    </div>
  );
}